import React from 'react';
import styled from 'styled-components';
import { DefaultTypography } from '@/components/typography';
import { getSeriesColor } from '@/features/details/charts/index';
import { HSpace } from '@/components/spacing';
import { breakpoints } from '@/components/responsive';

export function Legend({ variations }: { variations: string[] }) {
  return (
    <Wrapper>
      <Inner>
        {variations?.map((v, idx) => (
          <LegendItem key={`${v}${idx}space`} name={v} />
        ))}
      </Inner>
    </Wrapper>
  );
}
const Inner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${breakpoints.down(`md`)} {
    gap: 1rem;
    flex-wrap: wrap;
  }
`;

const Wrapper = styled.div`
  width: 94%;
  position: absolute;
  display: flex;
  justify-content: end;

  ${breakpoints.down(`md`)} {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: unset;
  }
`;

function LegendItem({ name }: { name: string }) {
  return (
    <>
      <HSpace className="only-desktop" />
      <ItemWrapper>
        <Dot color={getSeriesColor(name)} />
        <Caption>{name}</Caption>
      </ItemWrapper>
    </>
  );
}

const ItemWrapper = styled.div`
  border: 1px solid #f1f1f1;
  border-radius: 2rem;
  padding: 0.8rem 1.5rem;
  display: grid;
  grid-template-columns: 1.1rem 1fr;
  grid-gap: 1rem;
  align-items: center;

  ${breakpoints.down(`md`)} {
    padding: 0.7rem 1rem;
    grid-gap: 0.7rem;
  }
`;

const Caption = styled(DefaultTypography)`
  && {
    font-size: 1.2rem;
    font-weight: 500;

    ${breakpoints.down(`md`)} {
      font-size: 1rem;
    }
  }
`;

const Dot = styled.span`
  border-radius: 50%;
  background-color: ${(props: { color: string }) => props.color};
  height: 1.1rem;
  width: 1.1rem;
  ${breakpoints.down(`md`)} {
    height: 0.8rem;
    width: 0.8rem;
  }
`;
